import { render } from "./Receipt.vue?vue&type=template&id=61ec1c24&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import "./Receipt.vue?vue&type=style&index=0&id=61ec1c24&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec1c24"]])

export default __exports__